import LanguageService from "./../services/LanguageService";
import { apiLanguage, apiLanguages } from "@/core/modules/LanguageApi";

export default {
  namespaced: true,
  state: () => ({
    languages: [],
    apiLanguage: apiLanguage,
    languagesDetails: apiLanguages
  }),
  getters: {
    lang: state => state.lang,
    isApiLangExist: state => state.apiLanguage,
    isLangDetailsExits: state => state.languagesDetails.length !== 0,
    /**
     * Api tarafından alınan langData'yı convert eder
     *
     * @param {object} state $store state
     * @param {object} data Convert Data
     *
     * @returns object
     */
    convertLangData: state => data => {
      let langs = Object.keys(state.languagesDetails),
        langData = {},
        props = [];

      /**
       * Data üzerindeki dillerden dil dizisi oluştur
       */
      let activeLangs = [];
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < langs.length; j++) {
          if (Object.prototype.hasOwnProperty.call(data[i], langs[j])) {
            activeLangs.push(langs[j]);
          }
        }
      }

      /**
       * Data üzerideki dil ile girilmiş değerleri
       * langData'ya çevir
       */
      for (let i = 0; i < activeLangs.length; i++) {
        if (typeof data[i] !== "undefined") {
          props = Object.keys(data[i][activeLangs[i]]);

          let lng = (langData[activeLangs[i]] = {});

          for (let ix = 0; ix < props.length; ix++) {
            lng[props[ix]] = data[i][activeLangs[i]][props[ix]];
          }
        }
      }

      return langData;
    },
    /**
     * langData'nın props'larına önek ekler
     *
     * 'tr-TR': {
     *    prefix + prop : ...
     * }
     *
     * @returns object
     */
    convertProps: () => (data, prefix) => {
      let opt = {};
      for (let o in data) {
        opt[o] = {};
        for (let p in data[o]) {
          opt[o][prefix + p[0].toLocaleUpperCase() + p.slice(1)] = data[o][p];
        }
      }
      return opt;
    }
  },
  mutations: {
    setLang: (state, lang) => {
      state.lang = lang;
    },
    setLanguages: (state, langs) => {
      state.languages = langs;
    },
    setApiLang: (state, lang) => {
      state.apiLanguage = lang;
    },
    setApiLanguagesDetails: (state, langs) => {
      state.languagesDetails = langs;
    }
  },
  actions: {
    getLang: ({ getters }, langKey) => {
      if (getters.lang[langKey]) {
        return getters.lang[langKey];
      }
    },
    /**
     * Api üzerinde desteklenen dilleri listesi
     *
     * @returns array
     */
    getApiLanguages: ({ commit }) => {
      return new Promise((resolve, reject) => {
        LanguageService.apiLanguages()
          .then(res => {
            commit("setLanguages", res.data);
            resolve(res);
          })
          .catch(err => reject(err));
      });
    },
    setLang: ({ commit }) => {
      return LanguageService.panelLanguage().then(res => {
        commit("setLang", res.data);
        return res;
      });
    },
    setApiLang: ({ commit }) => {
      return LanguageService.apiLanguage().then(res => {
        localStorage.setItem("api-lang", JSON.stringify(res.data));
        commit("setApiLang", JSON.parse(localStorage.getItem("api-lang")));
      });
    },
    setLangsDetails: ({ commit }) => {
      return LanguageService.apiLanguagesDetails().then(res => {
        localStorage.setItem("langs-details", JSON.stringify(res.data));
        commit("setApiLanguagesDetails", JSON.parse(localStorage.getItem("langs-details")));
      });
    },
    /**
     * Apinin varsayılan dilini getirir
     *
     * @returns object
     */
    getApiLanguage: ({ commit }) => {
      return new Promise((resolve, reject) => {
        LanguageService.apiLanguage()
          .then(res => {
            commit("setApiLang", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * Api Languages'i detaylı açıklamaları ile beraber
     * verir.
     */
    getApiLanguagesDetails: ({ commit }) => {
      return new Promise((resolve, reject) => {
        LanguageService.apiLanguagesDetails()
          .then(res => {
            commit("setApiLanguagesDetails", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
